module.exports = __webpack_public_path__ + "img/Dental3d_1.792e63be.png";